var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("b-card", { staticClass: "rounded-0" }, [
    _c("h4", [
      _vm._v(_vm._s(_vm.$t("message.signUpContactPersonRejected.title")))
    ]),
    _vm._v(" "),
    _c("p", { domProps: { innerHTML: _vm._s(_vm.message) } })
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-98482a38", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-98482a38","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/auth/SignUpContactPersonRejected.vue
// module id = 3EKZ
// module chunks = 1